<template>
  <div class="home_page" :class="{ home_page_grayscale: grayscale }">
    <!-- 轮播展示 -->
    <div class="rotation_chart">
      <!-- 轮播框 -->
      <el-carousel class="rotation_carousel" height="647px" :interval="5000">
        <el-carousel-item v-for="(item, index) in backgroundImg" :key="index">
          <div
            class="rotation_img"
            :style="'background-image: url(' + item + ');'"
          >
            <div class="title" v-show="index == 0">
              赋能行业绿色转型&emsp;培育新质生产力
            </div>
            <div class="warn" v-show="index == 0">
              以数智技术为核心的行业信息化和产业化经营解决方案提供商
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <el-carousel
        class="rotation_carousel_small"
        height="40.4375rem"
        :interval="5000"
      >
        <el-carousel-item v-for="(item, index) in backgroundImg" :key="index">
          <div
            class="rotation_img"
            :style="'background-image: url(' + item + ');'"
          >
            <div class="title" v-show="index == 0">
              赋能行业绿色转型&emsp;培育新质生产力
            </div>
            <div class="warn" v-show="index == 0">
              以数智技术为核心的行业信息化和产业化经营解决方案提供商
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="handset_img">
        <div class="handset_title">赋能行业绿色转型&emsp;培育新质生产力</div>
        <div class="handset_warn">
          以数智技术为核心的建筑垃圾行业信息化和产业化经营解决方案提供商
        </div>
      </div>
      <!-- NavMenu 导航菜单 -->
      <rotation :select="tabber" @selectTabber="selTabber"></rotation>
    </div>
    <!-- 公司介绍 -->
    <home-company @selTabber="selTabber"></home-company>
    <!-- 产品与服务 -->
    <home-service
      :selectId="serviceSelect"
      @selTabber="selTabber"
      @goService="goService"
    ></home-service>
    <!-- 解决方案 -->
    <home-programme @selTabber="selTabber" @goSolve="goSolve"></home-programme>
    <!-- 应用案例 -->
    <home-case @goDases="goDases" @goCasesDet="goCasesDet"></home-case>
    <!-- 行业资讯 -->
    <home-journalism
      @selTabber="selTabber"
      @gotoDetails="gotoDetails"
      :list="list"
    ></home-journalism>
    <div style="height: 2rem"></div>
    <bottomBar></bottomBar>
  </div>
</template>

<script>
import { queryPage } from "@/api/consult/news";
import bottomBar from "../../components/bottomBar";
import backtop from "../../components/backtop";
import rotation from "../../components/rotation";
import homeCompany from "./components/home-company";
import HomeService from "./components/home-service";
import homeProgramme from "./components/home-programme";
import HomeCase from "./components/home-case.vue";
import HomeJournalism from "./components/home-journalism.vue";
export default {
  // 组件引入
  components: {
    bottomBar,
    backtop,
    rotation,
    homeCompany,
    HomeService,
    homeProgramme,
    HomeCase,
    HomeJournalism,
  },
  data() {
    return {
      serviceSelect: 0, //产品服务选中
      tabber: 0, //标题栏选中
      isVideo: false,
      list: [],
      grayscale: false, //页面灰色控制
      backgroundImg: [
        "/static/img/index/rotation01.png",
        "/static/img/index/rotation02.png",
        "/static/img/index/rotation03.png",
      ],
    };
  },
  mounted() {
    queryPage({
      current: 1,
      size: 10,
      status: "0",
    })
      .then((res) => {
        console.log(res, "queryPage");
        // this.pageSize = res.             //每页显示条目个数
        this.list = res.records;
        this.list.forEach((item) => {
          item.update_time = item.updateTime.slice(0, 10);
        });
        console.log("fanhui", res);
      })
      .catch((err) => {
        console.log("12112", err);
      });
    // getNews({
    //   pageNo: 1,
    //   pageSize: 10,
    //   status: 1,
    // })
    //   .then((res) => {
    //     this.list = res.data;
    //     console.log("fanhui", res);
    //   })
    //   .catch((err) => {
    //     console.log("12112", err);
    //   });
  },
  destroyed() {},
  metaInfo() {
    return {
      title: "小绿官网-赋能行业绿色转型 培育新质生产力",
      meta: [
        {
          name: "keywords",
          content:
            "青岛小绿,小绿,青岛小绿科技有限公司,建筑垃圾行业数字技术服务商,城市监管,数字开单,渣土车监管,智慧消纳,数字运营,渣土银行,装修垃圾处置",
        },
        {
          name: "description",
          content:
            "小绿是建筑垃圾行业数字技术服务商，致力于以用户需求为中心，为用户提供行业领先的“业务咨询+平台研发+运营管理”服务和相关物联终端。",
        },
      ],
    };
  },
  methods: {
    goService(id) {
      console.log(id);
      if (this.serviceSelect === id) {
        this.$router.push(`/product?id=${id}`);
        return;
      }
      this.serviceSelect = id;
    },
    selTabber(id) {
      this.tabber = id;
      if (id === 0) {
        this.$router.push("/");
      }
      if (id === 1) {
        this.$router.push("/product");
      }
      if (id === 2) {
        this.$router.push("/solve");
      }
      if (id === 3) {
        this.$router.push("/journalism");
      }
      if (id === 4) {
        this.$router.push("/about");
      }
    },
    goDases() {
      this.$router.push("/cases");
    },
    goCasesDet(e) {
      this.$router.push(`/cases/casesDetails?id=${e}`);
    },
    goSolve(e) {
      this.$router.push(`/solve?id=${e}`);
    },
    gotoDetails(e) {
      this.$router.push(`/journalism/jouDetails?id=${e}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.home_page_grayscale {
  filter: grayscale(100%);
}
.home_page_grayscale.o2_gray {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  -webkit-filter: gray;
  filter: gray;
  -webkit-filter: progid:dximagetransform.microsoft.basicimage(grayscale=1);
  filter: progid:dximagetransform.microsoft.basicimage(grayscale=1);
}
@import url(./home.css);
@media screen and (min-width: 1200px) {
  .el-carousel__arrow {
    width: 72px;
    height: 72px;
    font-size: 36px;
  }
  .home_page {
    display: flex;
    flex-direction: column;
    align-items: center;
    .rotation_chart {
      position: relative;
      .rotation_carousel {
        width: 1920px;
        z-index: 1;
      }
      .rotation_carousel_small {
        display: none;
      }
      .rotation_img {
        height: 647px;
        width: 1920px;
        background-image: url("/static/img/index/rotation01.png");
        background-size: cover;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .title {
          font-weight: 600;
          font-size: 54px;
          letter-spacing: 0.02em;
          color: #ffffff;
        }
        .warn {
          margin-top: 26px;
          font-weight: 400;
          font-size: 26px;
          letter-spacing: 0.2em;
          color: #ffffff;
        }
      }
      .handset_img {
        display: none;
      }
    }
  }
}
@media screen and (min-width: 1000px) and (max-width: 1200px) {
  .el-carousel__arrow {
    width: 4.5rem;
    height: 4.5rem;
    font-size: 2.25rem;
  }
  .home_page {
    display: flex;
    flex-direction: column;
    align-items: center;
    .rotation_chart {
      position: relative;
      .rotation_carousel {
        display: none;
      }
      .rotation_carousel_small {
        width: 120rem;
        z-index: 1;
      }
      .rotation_img {
        height: 40.4375rem;
        width: 120rem;
        background-image: url("/static/img/index/rotation01.png");
        background-size: cover;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .title {
          font-weight: 600;
          font-size: 3.375rem;
          letter-spacing: 0.02em;
          color: #ffffff;
        }
        .warn {
          margin-top: 1.625rem;
          font-weight: 400;
          font-size: 1.625rem;
          letter-spacing: 0.2em;
          color: #ffffff;
        }
      }
      .handset_img {
        display: none;
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .home_page {
    // width: 1200rem;
    // overflow: hidden;
    margin-top: 3.625rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    .rotation_chart {
      position: relative;
      .rotation_carousel {
        display: none;
      }
      .rotation_carousel_small {
        display: none;
      }
      .rotation_img {
        display: none;
      }
      .handset_img {
        width: 23.4375rem;
        height: 10.3125rem;
        background-image: url("/static/img/index/rotation01.png");
        background-size: cover;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .handset_title {
          font-weight: bold;
          font-size: 1.125rem;
          text-align: center;
          letter-spacing: 0.03em;
          color: #ffffff;
        }
        .handset_warn {
          margin-top: 0.3125rem;
          width: 14.9375rem;
          height: 2.125rem;
          font-weight: 400;
          font-size: 0.75rem;
          line-height: 1.0625rem;
          text-align: center;
          letter-spacing: 0.03em;
          color: #ffffff;
        }
      }
    }
    .consulting_service {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue